import React from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Box, Typography, DialogActions, DialogContent, DialogTitle } from '@mui/material'
import { styled } from '@mui/material/styles'
import { dismissModal as dismissModalAction } from 'services/modal/redux/actions'
import MuiButton from '../common/MuiButton'
import './index.scss'

const StyledDialogTitle = styled(DialogTitle)(({ theme }) => ({
  padding: theme.spacing(3, 3, 2, 3),
  '& .MuiTypography-root': {
    fontSize: '1.375rem',
    fontWeight: 600,
    color: theme.palette.text.primary,
    lineHeight: 1.3,
  },
}))

const StyledDialogContent = styled(DialogContent)(({ theme }) => ({
  padding: theme.spacing(0, 3, 2, 3),
  flex: 1,
  display: 'flex',
  alignItems: 'center',
  '& .MuiTypography-root': {
    fontSize: '1rem',
    lineHeight: 1.6,
    color: theme.palette.text.secondary,
  },
}))

const StyledDialogActions = styled(DialogActions)(({ theme }) => ({
  padding: theme.spacing(2, 3, 3, 3),
  gap: theme.spacing(2),
  justifyContent: 'flex-end',
}))

const ConfirmModal = ({ dismissModal, onConfirm, header, confirmText, modalType }) => {
  const handleDismiss = (e) => {
    e.preventDefault()
    dismissModal()
  }

  const handleConfirm = async (e) => {
    e.preventDefault()
    await onConfirm()
    dismissModal()
  }

  const isDelete = modalType === 'delete'
  const label = isDelete ? 'Delete' : 'Confirm'
  const color = isDelete ? 'error' : 'primary'

  return (
    <Box sx={{ width: '100%', height: '100%', display: 'flex', flexDirection: 'column' }}>
      <StyledDialogTitle component="div">
        <Typography variant="subtitle1">{header}</Typography>
      </StyledDialogTitle>

      <StyledDialogContent>
        <Typography variant="body1">{confirmText}</Typography>
      </StyledDialogContent>

      <StyledDialogActions>
        <MuiButton variant="outlined" onClick={handleDismiss} sx={{ minWidth: '100px' }}>
          Cancel
        </MuiButton>
        <MuiButton
          variant="contained"
          color={color}
          onClick={handleConfirm}
          sx={{ minWidth: '100px' }}
        >
          {label}
        </MuiButton>
      </StyledDialogActions>
    </Box>
  )
}

ConfirmModal.propTypes = {
  confirmText: PropTypes.string,
  header: PropTypes.string,
  dismissModal: PropTypes.func.isRequired,
  onConfirm: PropTypes.func,
  modalType: PropTypes.oneOf(['confirm', 'delete']),
}

ConfirmModal.defaultProps = {
  header: 'Confirm Action',
  confirmText: 'Are you sure you want to do this?',
  modalType: 'confirm',
}

export default connect(
  () => ({}),
  (dispatch) =>
    bindActionCreators(
      {
        dismissModal: dismissModalAction,
      },
      dispatch,
    ),
)(ConfirmModal)
